import { SharedPartnerService } from '@/shared/api/services/partner/partner.ts';

export class PartnerService extends SharedPartnerService {}
